const API_URLS = {
  local: "http://127.0.0.1:5050",
  hosted: "https://akkorent-production.up.railway.app",
};

const isValidApiMode = (mode) => mode === "local" || mode === "hosted";

const requestedMode = (process.env.REACT_APP_API_MODE || "").toLowerCase();
const fallbackMode = process.env.NODE_ENV === "production" ? "hosted" : "local";
const selectedMode = isValidApiMode(requestedMode)
  ? requestedMode
  : fallbackMode;

const API_BASE_URL = (
  process.env.REACT_APP_API_BASE_URL || API_URLS[selectedMode]
).replace(/\/+$/, "");

export const fetchWithTimeout = async (input, options = {}, timeoutMs = 15000) => {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), timeoutMs);

  try {
    return await fetch(input, { ...options, signal: controller.signal });
  } finally {
    clearTimeout(timeout);
  }
};

export const API_ENDPOINTS = {
  // Auth endpoints
  AUTH: {
  },

  //popular categories
  CATEGORIES: {
    POPULAR: `${API_BASE_URL}/api/categories/popular`,
  },

  // Items endpoints
  ITEMS: {
    CREATE: `${API_BASE_URL}/api/items/`,
    CATEGORIES: `${API_BASE_URL}/api/categories`,
    MEDIA_SIGN: `${API_BASE_URL}/api/items/media/sign`,
  },
  // Products endpoints (Unified Search)
  PRODUCTS: {
    SEARCH: `${API_BASE_URL}/api/products`,
    HOMEPAGE: `${API_BASE_URL}/api/products/homepage`,
    FEATURED: `${API_BASE_URL}/api/products/featured`,
    NEW_ARRIVALS: `${API_BASE_URL}/api/products/new-arrivals`,
    VIEW: `${API_BASE_URL}/api/products`,
  },

  // Homepage carousel
  HOMEPAGE: {
    SLIDERS: `${API_BASE_URL}/api/homepage/sliders`,
  },

  //wishlist (fetch wishlisted items, add item in wishlist, remove item from wishlist)
  WISHLIST: {
    ROUTE: `${API_BASE_URL}/api/wishlist`,
  },

  // Account settings endpoints
  ACCOUNT: {
    PROFILE: `${API_BASE_URL}/api/account/`,
    UPDATE_PROFILE: `${API_BASE_URL}/api/account/update`,
  },
  // Seller endpoints
  SELLER: {
    STATS: `${API_BASE_URL}/api/products/dashboard/stats`,
    MY_PRODUCTS: `${API_BASE_URL}/api/items/by-user`,
    UPDATE_PRODUCT: `${API_BASE_URL}/api/items`,
    ANALYTICS: `${API_BASE_URL}/api/products/analytics/trend`,
  },

  // Product promotions (Offer of the Day)
  PROMOTIONS: {
    BASE: `${API_BASE_URL}/api/promotions`,
  },

  // Listing publish payments (Dodo — India / INR)
  LISTING_PAYMENTS: {
    FEES: `${API_BASE_URL}/api/listing-payments/fees`,
    CHECKOUT: `${API_BASE_URL}/api/listing-payments/checkout`,
    RETURN: `${API_BASE_URL}/api/listing-payments/return`,
    BY_ID: (paymentId) => `${API_BASE_URL}/api/listing-payments/${paymentId}`,
  },
  // Seller subscriptions (AkkoRent Premium — Razorpay)
  SUBSCRIPTIONS: {
    PLANS: `${API_BASE_URL}/api/subscriptions/plans`,
    MY: `${API_BASE_URL}/api/subscriptions/my`,
    SUBSCRIBE: `${API_BASE_URL}/api/subscriptions/subscribe`,
    RETURN: `${API_BASE_URL}/api/subscriptions/return`,
    QUOTA: (category) => `${API_BASE_URL}/api/subscriptions/quota/${category}`,
  },
  // Contact endpoint
  CONTACT: {
    SUBMIT: `${API_BASE_URL}/api/contact/submit`,
  },
  // Chatbot endpoints
  CHATBOT: {
    CHAT: `${API_BASE_URL}/api/chatbot/chat`,
    SUGGESTIONS: `${API_BASE_URL}/api/chatbot/suggestions`,
    HEALTH: `${API_BASE_URL}/api/chatbot/health`,
    SELLER_CHAT: `${API_BASE_URL}/api/chatbot/seller/chat`,
    SELLER_SUGGESTIONS: `${API_BASE_URL}/api/chatbot/seller/suggestions`,
  },
  // Notification endpoints
  NOTIFICATIONS: {
    WS: `${API_BASE_URL.replace(/^http/, "ws")}/ws/notifications`,
    LIST: `${API_BASE_URL}/api/notifications/`,
    MARK_READ: `${API_BASE_URL}/api/notifications/`, // append ID/read
    MARK_ALL_READ: `${API_BASE_URL}/api/notifications/read-all`,
    UNREAD_COUNT: `${API_BASE_URL}/api/notifications/unread-count`,
  },

  // Review endpoints
  REVIEW: {
    SUBMIT: `${API_BASE_URL}/api/review/`,
    GET: `${API_BASE_URL}/api/review/`,
    BATCH_STATS: `${API_BASE_URL}/api/review/stats/batch`,
    SELLER_REVIEWS: `${API_BASE_URL}/api/review?target_type=user`,
    ME: `${API_BASE_URL}/api/review/me`,
  },
};

export default API_BASE_URL;
